export default "__VITE_ASSET__092137aa__"